import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import t from '../translations';

export default function HowJyotiWorksPage() {
  const navigate = useNavigate();
  const { lang }  = useLang();
  const tr        = t[lang];

  const steps = [
    {
      icon: '🌐',
      title: 'Your Eternal Birth Chart',
      body: 'When you register, Jyoti calculates your complete Vedic birth chart using the Swiss Ephemeris (Lahiri Ayanamsa) — the gold standard in Jyotish. Your Sun sign, Moon sign, Ascendant, and all 9 planets are placed across 12 houses.',
    },
    {
      icon: '🌙',
      title: "Today's Moon Transit",
      body: "Every day, Jyoti tracks where the Moon is transiting in real-time and maps it against YOUR natal Ascendant. The Moon's house transit is one of the most powerful short-term influences in Vedic astrology.",
    },
    {
      icon: '⏳',
      title: 'Vimshottari Dasha',
      body: "Jyoti calculates your current Mahadasha (major period) and Antardasha (sub-period) based on your exact birth Moon nakshatra. The Dasha system reveals the overarching cosmic theme of your life right now — a 120-year cycle unique to Jyotish.",
    },
    {
      icon: '✦',
      title: 'Your Personalised Reading',
      body: 'All three layers — Natal chart + Moon transit + Dasha — are combined with the Day Lord and sent to Jyoti (our AI Vedic astrologer). Jyoti uses these to craft a deeply personalised reading with colour, food, routine, remedy, and cosmic wisdom every single day.',
    },
    {
      icon: '📍',
      title: 'Muhurtas & Chaughadiyas',
      body: "Auspicious timings are calculated using YOUR current location. Jyoti computes sunrise and sunset for your city and divides the day into precise Chaughadiya (15-min) periods, Brahma Muhurta, Abhijit Muhurta, and Rahu Kaal — all specific to where you are today.",
    },
  ];

  return (
    <div data-testid="how-jyoti-works-page" style={{ minHeight: '100vh', background: '#0A0F1E', padding: '52px 20px 48px' }}>

      <button
        data-testid="back-btn"
        onClick={() => navigate(-1)}
        style={{
          background: 'none', border: 'none', color: '#C9A84C',
          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4,
          fontSize: 14, padding: 0, marginBottom: 28,
        }}
      >
        <ChevronLeft size={18} /> Back
      </button>

      <div style={{ textAlign: 'center', marginBottom: 36 }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>✦</div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: '#F5F0E8', marginBottom: 8 }}>
          {tr.howJyotiWorks}
        </h1>
        <p style={{ fontSize: 14, color: '#8A8580', lineHeight: 1.6 }}>
          Jyoti uses three layers of Vedic science to craft your reading — not generic horoscopes.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {steps.map((step, i) => (
          <div key={i} className="card fade-in-up" style={{ animationDelay: `${i * 0.1}s` }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div style={{
                fontSize: 24, flexShrink: 0,
                width: 44, height: 44, borderRadius: 12,
                background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {step.icon}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 14, fontWeight: 700, color: '#F5F0E8', marginBottom: 6 }}>{step.title}</p>
                <p style={{ fontSize: 13, color: '#8A8580', lineHeight: 1.7 }}>{step.body}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Disclaimer */}
      <div style={{ marginTop: 24, padding: '16px', background: 'rgba(255,255,255,0.02)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.05)' }}>
        <p style={{ fontSize: 11, color: 'rgba(138,133,128,0.6)', lineHeight: 1.7, textAlign: 'center' }}>
          {tr.readingDisclaimer}
        </p>
      </div>

      <div style={{ textAlign: 'center', marginTop: 32 }}>
        <button
          className="btn-primary"
          onClick={() => navigate('/paywall')}
          style={{ maxWidth: 260, margin: '0 auto' }}
        >
          {tr.subscribeNow}
        </button>
      </div>
    </div>
  );
}
